import Image from "@Components/Image";
import styles from "./HeroImageHolder.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import { SCHOLARSHIP_PAGE_STATIC_URL } from "constants/index";

const HeroImageContainer = () => (
  <div>
    <div className={styles.heroImageContainer}>
      <Image
        src={`${SCHOLARSHIP_PAGE_STATIC_URL}/scholar_hero.png`}
        height={536.986}
        width={795.176}
        alt="Hero Image"
      />
    </div>
  </div>
);

export default wrapperHOC(HeroImageContainer, {
  componentName: "HeroImageContainer-ScholarshipDesktop",
  showForChina: true,
});
